module.exports = __webpack_public_path__ + "static/img/big_logo.6c8bd8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big_logo.png
// module id = AwPU
// module chunks = 1